import { ResizeObserver as Polyfill } from '@juggle/resize-observer'
import 'core-js/features/array/at'

window.ResizeObserver = window.ResizeObserver ?? Polyfill
